import * as React from "react";
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../Services/AuthContext";
import {Link, useOutletContext} from "react-router-dom";
import {DetailsList, IconButton, PrimaryButton, SelectionMode, TooltipHost} from "@fluentui/react";
import {filterTasks, formatComments, modifyTask, sortColumns, taskWarning} from "../../Utilities/taskFunctions"
import {CSVDownloader} from "react-papaparse";
import AddTaskComment from "../../Panel/Task/AddTaskComment";

function TaskClosed() {
    const [user] = useContext(AuthContext);
    const [tasks, setTasks] = useState([]);
    const [sort, setSort] = useState({key: 'created'})
    const {userFilter, searchbox} = useOutletContext();
    const [filteredTasks, setFilteredTasks] = useState([])
    const [addComment, setAddComment] = useState(false);

    const [refresh, setRefresh] = useState(0);

    const _sort = (e, col) => setSort(col);

    const taskActions = (item) => {
        return (<IconButton iconProps={{iconName: 'History'}} onClick={() => modifyTask(item.id, 'revert', [], user, setRefresh)} />)
    }

    const taskAssignment = (item) => {
        return (<span>{item.assigned_to_name}</span>)
    }

    useEffect(() => {
        const abortController = new AbortController();
        setTasks([]);
        async function fetchData() {
            await fetch(`/api/task/closed`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setTasks(data.tasks);
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [refresh]);


    useEffect(() => {
        sortColumns(columns, sort, setColumns, tasks, setTasks);
    }, [sort]);


    useEffect(() => {
        filterTasks(tasks, userFilter, user, searchbox, setFilteredTasks);
    }, [userFilter, tasks, searchbox]);


    const [columns, setColumns] = useState([
        {
            key: 'description',
            name: 'Opis',
            ariaLabel: 'Opis',
            fieldName: 'description',
            minWidth: 200,
            isResizable: true,
            isRowHeader: true,
            onColumnClick: _sort
        },

        {
            key: 'assigned_to',
            name: 'Przypisane do',
            ariaLabel: 'Przypisane do',
            fieldName: 'assigned_to',
            minWidth: 180,
            isResizable: true,
            onRender: taskAssignment,
        },
        {
            key: 'type',
            name: 'Typ',
            ariaLabel: 'Typ',
            fieldName: 'type',
            minWidth: 90,
            maxWidth: 150,
            isResizable: true,
            hide: true
        },
        {
            key: 'contractor',
            name: 'Wykonawca',
            ariaLabel: 'Wykonawca',
            fieldName: 'contractor',
            minWidth: 120,
            isResizable: true,
            onColumnClick: _sort,
        },
        {
            key: 'venture',
            name: 'Kontrakt',
            ariaLabel: 'Kontrakt',
            fieldName: 'venture',
            minWidth: 120,
            isResizable: true,
            onColumnClick: _sort,
        },
        {
            key: 'project',
            name: 'Projekt',
            ariaLabel: 'Projekt',
            fieldName: 'project',
            minWidth: 150,
            isResizable: true,
            isCollapsible: true,
            onColumnClick: _sort,
            onRender: (item) => (
                item.project_id !== null && (
                    <Link to={`/project/${item.project_id}`}>
                        <PrimaryButton text={item.project} />
                    </Link>
                )
            )
        },
        {
            key: 'comment',
            name: 'Komentarze',
            ariaLabel: 'Komentarze',
            fieldName: 'comment',
            minWidth: 45,
            isResizable: false,
            onRender: (item) => (<TooltipHost tooltipProps={formatComments(item)}>
                <IconButton onClick={() => setAddComment(item.id)} iconProps={{iconName: 'Comment'}}/></TooltipHost>)
        },
        {
            key: 'created',
            name: 'Utworzono',
            ariaLabel: 'Utworzono',
            fieldName: 'created',
            minWidth: 130,
            isResizable: false,
            isSorted: true,
            onRender: taskWarning,
            onColumnClick: _sort,
        },
        {
            key: 'edit',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'edit',
            minWidth: 130,
            maxWidth: 130,
            isResizable: true,
            onRender: taskActions
        }
    ]);
    return (
        <div>
            <DetailsList items={filteredTasks} columns={columns} selectionMode={SelectionMode.none} constrainMode={0}/>
            <CSVDownloader data={tasks} filename={`zadania`} bom={true} config={{delimiter: ';'}}><IconButton iconProps={ {iconName: 'ExcelDocument' }} title='Export CSV'/></CSVDownloader>
            <AddTaskComment onSuccess={() => setRefresh(refresh + 1)} add={addComment} dismissPanel={() => setAddComment(false)}/>
        </div>
    );
}

export default TaskClosed